export default __webpack_public_path__ + "static/media/globe_tech.544c314a.png";